import React, { useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Badge from '@material-ui/core/Badge';
import Icon from '@material-ui/core/Icon';
import OrderHistory from '../../icons/OrderHistory';
// import Payment from '../../icons/Payment';
import useOrder from '../../hooks/orders';
import { withRouter } from 'react-router';
// import QRCode from '../../icons/QRCode';
import Wallet from '../../icons/Wallet';
import usePod from '../../hooks/pods';
import { APP_MAX_WIDTH } from '../../constants';
import useFirebase from '../../hooks/firebase';
import Tips from '../../icons/Tips';
import useTips from '../../hooks/tips';
import useAuth from '../../hooks/auth';
import useUser from '../../hooks/user';

const useStyles = makeStyles((theme) => ({
	bottomNav: {
		position: 'fixed',
		bottom: '0',
		width: '100%',
		height: '60px',
		padding: '0 10px',
		boxShadow: '0 0px 6px 0 rgba(0,0,0, 0.16)',
		maxWidth: APP_MAX_WIDTH,
		zIndex: 3,
		// left: 0,
	},
	badge: {
		backgroundColor: '#bfd730',
		color: 'black',
		fontSize: '16px',
		fontWeight: 600,
	},
	label: {
		transition: 'unset',
		fontSize: '12px',
		color: 'black',
		paddingTop: '6px',
		fontWeight: 500,
	},
	root: {
		minWidth: 'unset',
		padding: '6px',
		color: 'black',
		'&:disabled': {
			'& .MuiBottomNavigationAction-wrapper, & .MuiBottomNavigationAction-label, & .MuiIcon-root': {
				color: 'rgba(0,0,0, 0.4)',
			},
		},
	},
	qrBtn: {
		position: 'relative',
		top: '-14px',
		backgroundColor: 'white',
		borderRadius: '6px',
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
	},
	wrapper: {
		color: 'black',
	},
	menu: {
		width: '22px',
		height: '23px',
		overflow: 'hidden',
		fontSize: '24px',
		color: 'inherit',
	},
	selected: {
		minWidth: 'unset',
		padding: '6px',
		borderTop: '5px solid #f05b83',
		'& .MuiBottomNavigationAction-wrapper, & .MuiBottomNavigationAction-label, & .MuiIcon-root': {
			color: '#f05b83',
		},
	},
}));

const PendingOrders = ({ classes, count }) => (
	<Badge classes={{ badge: classes.badge }} badgeContent={count} color='primary'>
		<OrderHistory className={classes.menu} />
	</Badge>
);

PendingOrders.defaultProps = {
	count: 0,
	classes: {},
};

function BottomNav({ history, location }) {
	const classes = useStyles();
	const [orderState, , fetchOrders, handleSelectOrder, , syncPendingOrders, cancelSyncPendingOrders] = useOrder();
	const { pendingOrders = [], orderHistory } = orderState;
	const [{ selectedPod = null, affiliateData = null, affiliateActive} = {}] = usePod();
	const [logEvent] = useFirebase();
	const [, toggleTips] = useTips();
	const [{ sessionId } = {}] = useAuth();
	const [{ mobile } = {}] = useUser();

	const selectedNav = useMemo(() => {
		const path = location.pathname.split('/', 2);

		switch (path[1]) {
			case 'wallet':
				return 'WALLET';

			case 'orders':
				return 'ORDER_HISTORY';

			case 'products':
			case 'affiliate':
				return 'SHOP';

			default:
				break;
		}
	}, [location]);

	useEffect(() => {
		if (mobile && sessionId) {
			syncPendingOrders();
			fetchOrders();
			return () => {
				cancelSyncPendingOrders();
			};	
		}
	}, [cancelSyncPendingOrders, fetchOrders, mobile, sessionId, syncPendingOrders]);

	const handleChange = (event, newValue) => {
		if (newValue) {
			switch (newValue) {
				case '/orders/pending-order':
					if (pendingOrders.length > 0) {
						handleSelectOrder(pendingOrders[0]);
						return history.push(`/orders/${pendingOrders[0].order_id}/invoice`);
					}
					return;

				// case "HAMBURGER":
				//   return toggleDrawer(true);

				case 'SUPPORT':
					if (orderHistory && orderHistory.length > 0) {
						handleSelectOrder(orderHistory[0]);
						history.push(`/orders/${orderHistory[0].order_id}/help`);
						logEvent('view_customer_support');
					}
					return;

				case 'ORDER_HISTORY':
					handleSelectOrder(null);
					return history.push('/orders/order-history');

				case 'WALLET':
					return history.push('/wallet');

				case 'SHOP':
					if (affiliateActive && affiliateData) {
						const { url } = affiliateData;
						if (url) {
							return history.push(url, { navigated: true });
						}
					}
					if (selectedPod) {
						return history.push('/products');
					}

					if (orderHistory && orderHistory.length > 0) {
						return history.push({
							pathname: '/products',
							state: { selectPod: orderHistory[0].vm_imei_id },
						});
					}
					return history.push('podlist');

				case 'TIPS':
					toggleTips(true);
					break;

				default:
					history.push(newValue);
					break;
			}
		}
	};

	return (
		<BottomNavigation onChange={handleChange} className={classes.bottomNav} showLabels>
			{/* <BottomNavigationAction
        label="Menu"
        value="HAMBURGER"
        icon={<Icon classes={{ root: classes.menu }}> menu </Icon>}
        classes={{
          label: classes.label,
          root: selectedNav === "HAMBURGER" ? classes.selected : classes.root
        }}
      /> */}
			{/* <BottomNavigationAction
				label='Support'
				value='SUPPORT'
				disabled={!orderHistory || orderHistory.length <= 0}
				icon={<Icon classes={{ root: classes.menu }}> help_outline </Icon>}
				classes={{ label: classes.label, root: classes.root }}
			/> */}
			{/* <BottomNavigationAction value="favorites" icon={<QRCode />} 
        classes={{label: classes.label, root: classes.qrBtn}}/> */}
			{/* <BottomNavigationAction label="Scan" value="/podlist/?scanqr=true" icon={<QRCode />} 
        classes={{label: classes.label, root: classes.root, wrapper: classes.wrapper}}/> */}
			<BottomNavigationAction
				label='Tips'
				value='TIPS'
				icon={<Tips />}
				classes={{ label: classes.label, root: classes.root }}
			/>
			<BottomNavigationAction
				label='Shop'
				value='SHOP'
				icon={<Icon classes={{ root: classes.menu }}> add_shopping_cart </Icon>}
				classes={{
					label: classes.label,
					root: selectedNav === 'SHOP' ? classes.selected : classes.root,
				}}
			/>
			<BottomNavigationAction
				selected={true}
				label='Wallet'
				value='WALLET'
				icon={<Wallet />}
				classes={{
					label: classes.label,
					root: selectedNav === 'WALLET' ? classes.selected : classes.root,
					wrapper: classes.wrapper,
				}}
			/>
			<BottomNavigationAction
				label='Orders'
				value='ORDER_HISTORY'
				icon={<PendingOrders classes={classes} count={pendingOrders.length} />}
				classes={{
					label: classes.label,
					root: selectedNav === 'ORDER_HISTORY' ? classes.selected : classes.root,
					wrapper: classes.wrapper,
				}}
			 />
		</BottomNavigation>
	);
}

export default withRouter(BottomNav);
